import React from 'react'
import Root from './Pages/Root'

const App = () => {
  return (
    <React.Fragment>
      <Root/>
    </React.Fragment>
  )
}

export default App
